<template>
    <div class="wrapper">
        <div class="background" />
        <div class="main">
            <router-view
                :key="$route.path"
                class="child-view"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.wrapper {
    position: relative;
    z-index: 10;
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
}

.background {
    @include fill;

    position: fixed;
    background: $c-surface-raised;
    background-image: url('/images/subscrpiption-background.jpg');
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
}

.main {
    position: relative;
    width: 1024px;
    max-width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    text-align: center;
}

.child-view {
    padding-bottom: $s-h;
}

@include tablet {
    .main {
        padding: $s-h 0;
        text-align: left;
    }
}
</style>
